import { createGlobalState } from 'react-global-hooks';

const isReadyState = createGlobalState(true);

export default isReadyState;
